import { Container } from 'pixi.js-legacy';

import DataPoint from './pixi-datapoint';
import PriceIndicator from './pixi-price-indicator';

export default class HoverTooltips extends Container {
  private askIndicator: PriceIndicator; /** dynamic price indicators that moves on hover */

  private bidIndicator: PriceIndicator;

  private askShowStep: PriceIndicator; /** static indicators showing biggest step on graph */

  private bidShowStep: PriceIndicator;

  private fontName: string;

  private mouseDataPoint: DataPoint;

  private stepDataPoint: DataPoint;

  private parentWidth: number;

  private sideHeight: number;

  private getFormattedNumber: (value: number, isMarketPrecision?: boolean) => string;

  constructor({
    fontName,
    mouseDataPoint,
    stepDataPoint,
    parentWidth,
    sideHeight,
    getFormattedNumber,
  }: {
    fontName: string;
    mouseDataPoint: DataPoint;
    stepDataPoint: DataPoint;
    parentWidth: number;
    sideHeight: number;
    getFormattedNumber: (value: number, isMarketPrecision?: boolean) => string;
  }) {
    super();

    this.fontName = fontName;
    this.mouseDataPoint = mouseDataPoint;
    this.stepDataPoint = stepDataPoint;
    this.parentWidth = parentWidth;
    this.sideHeight = sideHeight;
    this.getFormattedNumber = getFormattedNumber;

    const indicatorDefaults = {
      fontName: this.fontName,
      sideHeight: this.sideHeight,
      parentWidth: this.parentWidth,
    };

    this.askIndicator = new PriceIndicator({
      ...indicatorDefaults,
      isAsk: true,
      isHoverable: true,
      getFormattedNumber: this.getFormattedNumber,
      name: 'askIndicator',
    });
    this.bidIndicator = new PriceIndicator({
      ...indicatorDefaults,
      isAsk: false,
      isHoverable: true,
      getFormattedNumber: this.getFormattedNumber,
      name: 'bidIndicator',
    });

    this.askShowStep = new PriceIndicator({
      ...indicatorDefaults,
      isAsk: true,
      isHoverable: false,
      getFormattedNumber: this.getFormattedNumber,
      name: 'askShowStep',
    });
    this.bidShowStep = new PriceIndicator({
      ...indicatorDefaults,
      isAsk: false,
      isHoverable: false,
      getFormattedNumber: this.getFormattedNumber,
      name: 'bidShowStep',
    });

    this.addChild(this.askIndicator, this.bidIndicator, this.askShowStep, this.bidShowStep);
  }

  public update() {
    this.askShowStep.update(this.stepDataPoint.askPosition);
    this.bidShowStep.update(this.stepDataPoint.bidPosition);

    if (!this.mouseDataPoint.isInsideCanvas) {
      this.toggleIndicators(false);

      return;
    }

    if (this.mouseDataPoint.askPosition && this.mouseDataPoint.bidPosition) {
      this.toggleIndicators(true);
      this.askIndicator.update(this.mouseDataPoint.askPosition);
      this.bidIndicator.update(this.mouseDataPoint.bidPosition);
    }
  }

  private toggleIndicators(b: boolean) {
    this.askIndicator.visible = b;
    this.bidIndicator.visible = b;
    this.askShowStep.visible = !b;
    this.bidShowStep.visible = !b;
  }
}
